import {GET_BANNED_PLAYERS as SOCKET_GET_BANNED_PLAYERS} from '../../events/ClientToServer'
import { normalize } from '../../utils/normalize'
import {PLAYER_MODERATED} from '../../events/ServerToClient'

export const GET_BANNED_PLAYERS = 'GET_BANNED_PLAYERS'
export const BANNED_PLAYERS_SENT = 'BANNED_PLAYERS_SENT'


export const bannedplayers = (state = [], action) => {
    switch (action.type) {
        case GET_BANNED_PLAYERS:
            return state    
       
        case BANNED_PLAYERS_SENT:
            return Object.assign({}, state, normalize(state, action.players))
        
        case PLAYER_MODERATED:
            const id = action.user.id;
            var newState = {};
            if (state[id]){
                delete state[id];
                newState = {...state}
            }else{
                newState =  {...state};
                newState[id] = action.user;
            }
            return newState;

        default:
            return state
    }
}


export const getBannedPlayers = (socket) => {
    socket.emit(SOCKET_GET_BANNED_PLAYERS)
    return {type: GET_BANNED_PLAYERS}
}

export const bannedPlayersSent = (players) => {
    return { type: BANNED_PLAYERS_SENT, players}
}

export const playerModerated = (user) => {
    return { type: PLAYER_MODERATED, user}
}




// WEBPACK FOOTER //
// ./src/reducers/bannedplayers/index.js